<template>
	<section class="page-section" id="contact">
		<div class="container px-4 px-lg-5">
			<div class="row gx-4 gx-lg-5 justify-content-center">
				<div class="col-lg-8 col-xl-6 text-center">
					<h2 class="mt-0">想说点什么吗？</h2>
					<hr class="divider" />
					<p class="text-muted mb-5">提交成功我就可以看到啦~</p>
				</div>
			</div>
			<div class="row gx-4 gx-lg-5 justify-content-center mb-5">
				<div class="col-lg-6">
					<form id="contactForm" data-sb-form-api-token="API_TOKEN">
						<!-- Name input-->
						<div class="form-floating mb-3">
							<input v-model="shuju.name" class="form-control" id="name" type="text" />
							<label for="name">名字</label>
						</div>
						<!-- Email address input-->
						<div class="form-floating mb-3">
							<input v-model="shuju.email" class="form-control" id="email" type="email" />
							<label for="email">电子邮件</label>
						</div>
						<!-- Phone number input-->
						<div class="form-floating mb-3">
							<input v-model="shuju.phone" class="form-control" id="phone" type="tel" />
							<label for="phone">电话号码</label>
						</div>
						<!-- Message input-->
						<div class="form-floating mb-3">
							<textarea v-model="shuju.message" class="form-control" id="message" type="text"
								style="height: 10rem"></textarea>
							<label for="message">想和我说点什么吗？</label>
						</div>
						<div class="d-grid">
							<input @click="post" class="btn-primary btn-xl disabled" id="submitButton" value="提交"
								type="button" />
						</div>
					</form>
				</div>
			</div>
			<div class="contact-information">其他联系方式</div>
			<div class="row gx-4 gx-lg-5 justify-content-center">
				<div class="col-lg-4 text-center mb-5 mb-lg-0">
					<a href="tel:19934014819">
						<i class="bi-phone fs-2 mb-3 text-muted"></i>
						<div>+86 19934014819</div>
					</a>
				</div>
				<div  class="col-lg-4 text-center mb-5 mb-lg-0">
					<a href="mailto:1584059986@qq.com">
						<i class="fs-2 mb-3 text-muted bi-envelope"></i>
						<div>1584059986@qq.com</div>
					</a>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	const AV = require('leancloud-storage');
	AV.init({
		appId: "coJvzqIgHkiuWHgUDuMtOC37-gzGzoHsz",
		appKey: "y9tnM5dWs5eC3ubS6OXIrSqm",
		serverURL: "https://cojvzqig.lc-cn-n1-shared.com",
	});
	export default {
		name: "Contact",
		data() {
			return {
				shuju: {
					name: "",
					email: "",
					phone: "",
					message: "",
				},
			};
		},
		methods: {
			post() {
				let em = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
				if (em.test(this.shuju.email)) {
					const land = AV.Object.extend("ContactMe");
					const data = new land();
					data.set("title", this.shuju);
					data.save().then(
						() => {
							alert("提交成功！撒花花~");
						},
						() => {
							alert("可能出现了一些问题，没有提交过去呢");
						}
					);
				} else {
					alert("请输入正确的邮箱格式啦！不然无法回信息啦！");
				}
			},
		},
	};
</script>

<style scoped>
	.contact-information {
		margin: 0 auto;
		width: fit-content;
		font-size: 20px;
	}
</style>
